import veoLogo from './PartnerLogos/veo-logo.png';
import ketherLogo from './PartnerLogos/kether-logo.png';

export const partnerLogosMap = {
    'veo': veoLogo,
    'ketherOS': ketherLogo
};
